export const Config = {
    linkBase: 'https://app.sprinta.com.br/',
    linkExplore: 'https://app.sprinta.com.br/explore',
    linkSearch: 'https://app.sprinta.com.br/search',
    linkHome: 'https://bora.club/',

    userURI: '',
    eventURI: '/event/',
    experienceURI: '/experience/',

    urlAPI: window.URL_API,
    assetsBase: window.URL_ASSETS_BASE,
    baseOld: window.URL_BASE_OLD,
    uriCheckout: "https://www.sprinta.com.br/checkout/c/",
    avatarNotificationURI: window.URL_ASSETS_BASE,
    myAccount: window.URL_BASE_OLD,
    createEvent: 'https://app.sprinta.com.br/create/event',
    myEvents: window.URL_BASE_OLD + 'dash',
    createExperience: 'https://app.sprinta.com.br/create/experience',

    imgEvent: window.URL_BASE_OLD + 'uploads/covers/',
    imgExperience: window.URL_BASE_OLD + 'uploads/covers/',
    imgUser: window.URL_BASE_OLD + 'imgs/avt/'
 }



// WEBPACK FOOTER //
// ./src/SPRINTA/Topbar/_config.js